import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

// Store's root state
import { RootState } from '@/store/store.types';

// All global store types, mutations, actions and getters
import { mutations } from '@/store/store.mutations';
import { actions } from '@/store/store.actions';
import { getters } from '@/store/store.getters';

// Section states
import { State as CompanyState } from '@/store/sections/company/company.state';
import { State as FooterState } from '@/store/sections/footer/footer.state';
import { State as ProductsState } from '@/store/sections/products/products.state';
import { State as RequestState } from '@/store/sections/request/request.state';
import { State as SpacesState } from '@/store/sections/spaces/spaces.state';
import { State as StepsState } from '@/store/sections/steps/steps.state';
import { State as SystemsState } from '@/store/sections/systems/systems.state';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
    state: {

        /**
         *  General state.
         */
        loading: true,
        internal: false,

        /**
         *  Every section's state.
         */
        ...CompanyState,
        ...FooterState,
        ...ProductsState,
        ...RequestState,
        ...SpacesState,
        ...StepsState,
        ...SystemsState,

    },
    mutations,
    actions,
    getters,
};

export default new Vuex.Store<RootState>(store);
